<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Vendas de Compras da Franquia de {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            <p class="bg-warning btn-round text-white col-md-12" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>
          <div class="col-md-12" align="right">
            <a :href="url" target="_blank"><button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile  btn-primary">Exportar Excel</button></a>
          </div>
          
          <table class=" responsive nowrap table table-hover table-striped table-bordered table-sm">
            <thead>
              <tr>
                <th></th>
                <th v-for="loja of lojas" v-if="loja" colspan="2">{{loja}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(produto,categoria) of valores" :index="categoria">
                <td style="font-weight:bold">{{categoria}}</td>
                <td style="font-weight:bold" v-for="total of valores[categoria].valores">{{total}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td v-for="total of vendas.totais" v-if="total !== 'Total'" colspan="2">{{total | currencyBrl(true)}}</td>
              </tr>
            </tfoot>
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
    Progress as NProgress,
    LineChart
  } from 'src/components'
import { setInterval } from 'timers';
import {Table, TableColumn} from 'element-ui'
import HeaderChart from '../Dashboard/HeaderChart'
import moment from 'moment'
import jQuery from 'jquery'
import GlobalFunctions from '../../../globalFunctions.js'
import VendaService from '@/services/VendaService.js'

export default {
    components: {
      Card,
      AnimatedNumber,
      LineChart,
      NProgress,
      HeaderChart,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(),
        vendas: [],
        total: 0,
        valores:{},
        lojas:[],
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadVendas()
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },
      filtrar() {
        this.valores = {};
        this.lojas = [];
        this.vendas = [];
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadVendas();
      },
      loadVendas() {
        let loader = this.$loading.show();
        let url = process.env.VUE_APP_API_URL + 'vendas/categoriasFiscal'
        let params =`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&excel=1&token=${localStorage.getItem("token")}`;
        VendaService.loadCategoriaFiscal(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`).then(res => {
          this.vendas = res.data.data;
          this.lojas = res.data.lojas;
          // console.log(this.lojas);
          console.log(this.vendas);
          let chave = Object.entries(Object.keys(this.vendas.lojas)[0])[0][1];
          for(let [key, value] of Object.entries(this.vendas.lojas[chave])) {
            // console.log("foi");
            this.valores[key] = [];
            this.valores[key].valores = [];
            for (let [produto, total] of Object.entries(this.vendas.lojas)) {
              // this.valores[key].push(total[key].total);
              this.valores[key].valores.push("R$"+total[key].total.toFixed(2));
              this.valores[key].valores.push(((total[key].total)*100/this.vendas.totais[produto]).toFixed(2)+"%");
              if(this.vendas.lojas[chave][key].categoria == true){
                this.valores[key].categoria = true;

              }
            }
          };
          loader.hide()
        }).catch(err => {
          loader.hide()
        });
        this.url = url+params;
      },

      getUnidade(unidade) {
        let unidades = [  
          "UN",
          "CT",
          "CX",
          "DZ",
          "GZ",
          "PA",
          "PC",
          "PR",
          "PT",
          "RL",
          "KG",
          "G",
          "SC60",
          "L",
          "M3",
          "M2",
          "CM2",
          "M",
          "CM",
          "X"
        ]

        console.log(unidades[unidade])
        return unidades[unidade];
      },
      exportaPDF(){
    
          VendaService.geraRelatorioDataPDF("?data_fim="+this.data_fim+"&data_inicio="+this.data_inicio).then(pdf =>{
            let data = pdf.data;
            
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            let name = "Relatório Por Data.pdf";
            // url = window.URL.createObjectURL(data);
            a.href = "data:application/pdf;base64,"+data;
            a.target= "_blank";
            a.download = name;
            a.click();
          })

          
      },
      exportaExcel(){
          VendaService.loadCategoria("?data_fim="+this.data_fim+"&data_inicio="+this.data_inicio+"&excel=1");
      },
      openImpostos(venda) {
        let html = '';

        html += "<h4 class='mb-1' style='font-size: 16px;'><strong>Informação da venda</strong></h4>";
        // html += "<h4 class='mb-4 mt-0' style='font-size: 16px;'>Informação da venda</h4>"
        html += "<div class='text-left ml-4 mt-4'><p style='font-weight: normal'><strong>Desconto</strong>: R$ " + this.$options.filters.currencyBrl(venda.desconto) + "</p>";
        html += "<p style='font-weight: normal'><strong>Produtos</strong></p>";

        for(let produto of venda.itens) {
          html += "<p style='font-weight: normal'>" + produto.produto_object.descricao + " Quantidade: " + produto.quantidade + "</p>";
        }

        html += "<p style='font-weight: normal'><strong>Pagamentos</strong></p>"

        for(let pagamento of venda.pagamentos) {
          html += "<p style='font-weight: normal'>" + pagamento.forma_pagamento_object.descricao + " R$: " + this.$options.filters.currencyBrl(pagamento.valor, false) + "</p>"
        }

        html += "</div>"

        this.$swal({
          html: html
        })
      }
    },
    mounted() {
      this.loadVendas()
    }
}
</script>